import React, { useMemo } from 'react'
import countryList from 'react-select-country-list'
import { PRIORITY_COUNTRIES } from '@components/form/constants'
import { isDefined } from '@lib/utils/is-defined'

export const CountryOptions: React.FC = () => {
  const countries = useMemo(() => {
    const countries = countryList().getData()
    const prioritizedCountries = PRIORITY_COUNTRIES.map((country) =>
      countries.find(({ label }) => label === country)
    ).filter(isDefined)
    const others = countries.filter(({ label }) => !PRIORITY_COUNTRIES.includes(label))
    return [...prioritizedCountries, ...others]
  }, [])

  return (
    <>
      {countries.map(({ value, label }) => (
        <option key={value} value={label}>
          {label}
        </option>
      ))}
    </>
  )
}
